/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ApiKey: core.serialization.ObjectSchema<serializers.ApiKey.Raw, Truvity.ApiKey> =
    core.serialization.object({
        expiration: core.serialization.date(),
        subjectId: core.serialization.property('subject_id', core.serialization.string()),
    });

export declare namespace ApiKey {
    export interface Raw {
        expiration: string;
        subject_id: string;
    }
}
